<template>
  <div v-if="infoData.id" class="category">
    <div class="top flex_c_start">
      <div class="video flex_r_start">
        <div class="flex1">
          <div class="infotitle f28 line40 fw600">
            {{ infoData.title }}
          </div>
          <p class="fgray f16 line22 margint12">{{ infoData.time }}</p>
        </div>
        <div v-if="infoData.author" class="publisher marginl16 flex0 flex_r">
          <img
            v-if="infoData.author.logo"
            :src="infoData.author.logo"
            class="ava flex0"
            alt=""
          />
          <div class="marginl12 flex1">
            <p @click="goAuthor(infoData.author.id)" class="name f20 cursor line28 fw600">{{ infoData.author.name }}</p>
            <p class="fgray flex0 f16 line22">
              粉丝 {{ infoData.author.fs }} 点赞{{ infoData.author.dz }}
            </p>
          </div>
          <div
            @click="setFollow"
            :class="[infoData.author.is_follow > 0 && 'active']"
            class="followAuthor marginl4"
          >
            {{ infoData.author.is_follow > 0 ? "已关注" : "关注" }}
          </div>
        </div>
      </div>
      <div class="info margint32 flex_r_start">
        <div class="">
          <div v-if="infoData.type<3" class="videoWrap">
            <video controls controlsList='nodownload' disablePictureInpicture :src="infoData.url"></video>
          </div>
          <div v-else class="videoWrap active flex_c_center">
            <svgIcon class="f64" name='defaultDoc' />
            <p class="f16 line22">此档案为文稿类型</p>
            <p class="f16 line22">请下载后查阅</p>
          </div>
          <div class="action f16 flex_r_between">
            <div @click="onPraise" class="flex_r cursor f16">
              <svgIcon name="nice" class="marginr8 f28" />{{
                infoData.dz
              }}{{infoData.is_dz>0?'取消点赞':'点赞'}}
            </div>
            <div @click="onSave" class="flex_r cursor f16">
              <svgIcon name="collect" class="marginr8 f28" />{{
                infoData.sc
              }}{{infoData.is_sc>0?'取消收藏':'收藏'}}
            </div>
            <div @click="onDownload" class="flex_r cursor flex1 f16">
              <svgIcon name="download" class="marginr8 f28" />{{
                infoData.xz
              }}下载
            </div>
            <div @click="onReport" class="flex0 cursor flex_r f16 fgray t_r">
              <svgIcon name="report" class="marginr8 f28" />举报
            </div>
          </div>
        </div>
        <div class="flex_c_start marginl16 article">
          <div class="videoType">
            <p class="f16 line28">
              <span class="fw600">主题：</span>{{ infoData.topic_txt  }}
            </p>
            <p class="f16 line28">
              <span class="fw600">类型：</span>{{ infoData.type_txt }}
            </p>
            <p class="f16 line28">
              <span class="fw600">地区：</span>{{ infoData.area }}
            </p>
            <p v-if="infoData.sex" class="f16 line28">
              <span class="fw600">性别：</span>{{ infoData.sex > 1 ? '女' : '男' }}
            </p>
            <p v-if="infoData.job_txt" class="f16 line28">
              <span class="fw600">职业：</span>{{ infoData.job_txt }}
            </p>
          </div>
          <div class="line"></div>
          <div class="make flex1 flex_c_start">
            <div class="arcitleTitle f20 line28 fw600">摘要/介绍</div>
            <div class="html margint12 flex1 f16 line28">
              {{ infoData.descp }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="read margint20">
      <div class="control f24 flex_r">
        <p class="bg">背景色</p>
        <span @click="setBg('#FBF6ED')"></span>
        <span @click="setBg('white')" class="active2"></span>
        <span @click="setBg('#EBF4EA')" class="active3"></span>
        <span @click="setBg('#E8F2F5')" class="active4"></span>
        <svgIcon
          @click.native="setFont('reduce')"
          :class="[font <= 14 && 'color']"
          name="reduce"
          class="f24 reduce"
        />
        <div>字号</div>
        <svgIcon
          @click.native="setFont('add')"
          :class="[font >= 22 && 'color']"
          name="add"
          class="f24 add"
        />
      </div>
      <div
        class="txt"
        v-html="infoData.content"
        :style="{ backgroundColor: bgColor, fontSize: font + 'px' }"
      >
      </div>
    </div>
    <div v-if="infoData.imgs && infoData.imgs.length" class="imgs pt60">
      <div class="flex_r_between">
        <div class="title f32 line44 fw600">相关图片</div>
        <!-- <div class="more f16 line22 ftheme">
          查看更多<svgIcon name="more" />
        </div> -->
      </div>
      <div class="imgList flex_r">
        <div
          v-for="(item, index) in infoData.imgs"
          :key="index"
          class="img flex0"
        >
          <!-- <img :src="item.url" alt="" /> -->
          <el-image 
            style="width: 284px; height: 284px"
            :src="item.url" 
            :preview-src-list="imgs">
          </el-image>
          <p>{{ item.note }}</p>
        </div>
      </div>
    </div>
    <div v-show="showFollow" class="mask flex_c_center">
      <div class="content flex_c_start">
        <el-radio
          v-model="check"
          v-for="(item, index) in myFollowDoc"
          :key="index"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
        <el-input
          v-model="input"
          maxlength="10"
          @input="changeInput"
          placeholder="添加到新的列表"
        ></el-input>
        <div class="margint20 btn">
          <el-button size="medium" @click.native="setDoc" type="primary"
            >确定</el-button
          >
        </div>
      </div>
      <div @click.stop="showFollow = !showFollow" class="close margint40">
        <svgIcon class="f40" name="close" />
      </div>
    </div>
    <div v-show="showSave" class="mask flex_c_center">
      <div class="content flex_c_start">
        <el-radio
          v-model="saveCheck"
          v-for="(item, index) in mySaveDoc"
          :key="index"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
        <el-input
          v-model="saveInput"
          maxlength="10"
          @input="changeSaveInput"
          placeholder="添加到新的列表"
        ></el-input>
        <div class="margint20 btn">
          <el-button size="medium" @click.native="setSaveDoc" type="primary"
            >确定</el-button
          >
        </div>
      </div>
      <div @click.stop="showSave = !showSave" class="close margint40">
        <svgIcon class="f40" name="close" />
      </div>
    </div>

    <!-- <div v-for="(item,index) in tonglan" :key="index" class="mainBanner">
      <a :href="item.url" target="_blank"><img :src="item.img" alt=""></a>
      <p>广告</p>
    </div> -->
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "info",
  props: ["infoid"],
  data() {
    return {
      id: "",
      infoData: {},
      bgColor: "white",
      font: 18,
      showFollow: false,
      showSave: false,
      myFollowDoc: [],
      mySaveDoc: [],
      input: "",
      saveInput: "",
      uid: "",
      check: 0,
      saveCheck: 0,
      imgs: [],
    };
  },
  mounted() {
    this.getUserInfo().then((res) => {
      this.uid = res.uid;
      this.getFollowDoc();
      this.getSaveDoc();
    });
    this.getData();
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    goAuthor(uid){
      this.$router.push({
        name: 'myindex',
        params: {
          uid
        }
      })
    },
    async onPraise() {
      if (!this.$isLogin()) return;
      let data = await this.$http.get(this.$api.setPraise, {
        params: {
          uid: this.uid,
          id: this.infoid,
          type: 0,
        },
      });
      this.getData()
      this.$message.success(data.msg);
    },
    async onDownload() {
      if (!this.$isLogin()) return;
      let aTag = document.createElement("a");
      let url = this.infoData.url;
      aTag.href = url;
      aTag.target = '_blank';
      aTag.download = this.infoData.title;
      aTag.style.display = "none";
      document.body.appendChild(aTag);
      aTag.click();
      document.body.removeChild(aTag);
      let data = await this.$http.get(this.$api.download, {
        params: {
          uid: this.uid,
          id: this.infoid,
        },
      });
      //this.$message.success(data.msg);
    },
    async onSave() {
      if(this.infoData.is_sc>0){
         let data = await this.$http.get(this.$api.setSave, {
          params: {
            uid: this.uid,
            id: this.infoData.sc_id,
            sdid: this.infoData.sc_doc_id, //文件夹id
          },
        });

        this.$message.success(data.msg);
        this.getData();
        return
      }
      this.setSave();
    },
    onReport() {
      if (!this.$isLogin()) return;
    },
    async getFollowDoc() {
      let data = await this.$http.get(this.$api.getFollowDoc, {
        params: { uid: this.uid },
      });
      this.myFollowDoc = data.data;
    },
    async getSaveDoc() {
      let data = await this.$http.get(this.$api.getSaveDoc, {
        params: { uid: this.uid },
      });
      this.mySaveDoc = data.data;
    },
    changeInput() {
      this.check = -1;
    },
    changeSaveInput() {
      this.saveCheck = -1;
    },
    async setDoc() {
      if (this.check > -1) {
        let data = await this.$http.get(this.$api.setFollow, {
          params: {
            uid: this.uid,
            id: this.infoData.author.id,
            sdid: this.check, //文件夹id
          },
        });
        this.getData();
        this.$message.success(data.msg);
      } else {
        if (!this.input && this.input != 0)
          return this.$alert("请选择添加列表");
        this.$http
          .get(this.$api["createFollowDoc"], {
            params: {
              uid: this.uid,
              name: this.input,
            },
          })
          .then(async (res) => {
            let data = await this.$http.get(this.$api.setFollow, {
              params: {
                uid: this.uid,
                id: this.infoData.author.id,
                sdid: res.data, //文件夹id
              },
            });
            this.$message.success(data.msg);
            this.getData();
          });
      }
      
      this.showFollow = !this.showFollow;
    },
    async setSaveDoc() {
      if (this.saveCheck > -1) {
        let data = await this.$http.get(this.$api.setSave, {
          params: {
            uid: this.uid,
            id: this.infoid,
            sdid: this.saveCheck, //文件夹id
          },
        });

        this.$message.success(data.msg);
      } else {
        if (!this.saveInput && this.saveInput != 0)
          return this.$alert("请选择添加列表");
        this.$http
          .get(this.$api["createSaveDoc"], {
            params: {
              uid: this.uid,
              name: this.saveInput,
            },
          })
          .then(async (res) => {
            let data = await this.$http.get(this.$api.setSave, {
              params: {
                uid: this.uid,
                id: this.infoid,
                sdid: res.data, //文件夹id
              },
            });
            this.$message.success(data.msg);
          });
      }
      this.getData();
      this.showSave = !this.showSave;
    },
    setSave() {
      if (!this.$isLogin()) return;
      if (!this.mySaveDoc[0]) {
        this.getSaveDoc();
      }
      this.showSave = !this.showSave;
    },
    async setFollow() {
      if (!this.$isLogin()) return;
      if (this.infoData.author.is_follow > 0) {
        let data = await this.$http.get(this.$api.setFollow, {
              params: {
                uid: this.uid,
                id: this.infoData.author.id,
                sdid: this.infoData.author.is_follow, //文件夹id
              },
            });
            this.getData();
            this.$message.success(data.msg);
        return;
      }
      if (!this.myFollowDoc[0]) {
        this.getFollowDoc();
      }
      this.showFollow = !this.showFollow;
    },
    setBg(bg) {
      this.bgColor = bg;
    },
    setFont(type) {
      if (type == "add") {
        if (this.font < 22) return (this.font += 2);
      }
      if (type == "reduce") {
        if (this.font > 14) return (this.font -= 2);
      }
    },
    async getData() {
      let uid = this.$getCookie('cy_uid');
      let data = await this.$http.get(this.$api.daInfo, {
        params: { id: this.infoid, uid: uid ? uid : "0" },
      });
      this.infoData = data.data;
      let imgs = [];
      if(!data.data.imgs.length)return
      let arr = data.data.imgs || []
      arr.forEach(item=>{
        imgs.push(item.url)
      })
      this.imgs = imgs;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-radio.is-bordered {
  margin-bottom: 10px;
}
/deep/ .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0;
}
.content {
  padding: 30px 50px;
  background: white;
}
.btn {
  width: 100%;
}
.top {
  overflow: hidden;
  .video {
    width: 100%;
    .infotitle {
      width: 824px;
      word-break: break-all;
      word-wrap: break-word;
      overflow: hidden;
    }
    .publisher {
      width: 344px;
      height: 74px;
      padding: 0 16px;
      box-sizing: border-box;
      background: #fafafa;
      .name:hover{
        color: #ad2729;
      }
      .ava {
        width: 52px;
        height: 52px;
        border-radius: 50%;
      }
      .followAuthor {
        width: 70px;
        height: 36px;
        color: white;
        text-align: center;
        line-height: 36px;
        background: #ad2729;
        &.active {
          background: rgba(173, 39, 41, 0.3);
        }
      }
    }
  }
  .info {
    width: 100%;
    overflow: hidden;
    .videoWrap {
      width: 824px;
      height: 618px;
      background: #000000;
      video {
        width: 100%;
        height: 100%;
      }
      &.active{
        background: #FCF8E9;
      }
    }
    .action {
      width: 100%;
      height: 58px;
      color: black;
      box-sizing: border-box;
      border-bottom: 2px solid #fafafa;
      & > div {
        padding: 0 23px;
      }
    }
    .article {
      width: 344px;
      height: 618px;
      overflow: hidden;
      padding: 24px 20px;
      background: #fafafa;
      box-sizing: border-box;
      .line {
        width: 304px;
        height: 2px;
        margin: 24px 0 20px;
        background: #e6e6e6;
      }
      .make {
        overflow: hidden;
        .html {
          padding: 0 10px 0 0;
          overflow-y: auto;
          overflow-x: hidden;
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: #f5f5f5;
          }
          &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            background-color: #f5f5f5;
          }

          /*定义滑块 内阴影+圆角*/
          &::-webkit-scrollbar-thumb {
            box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            background-color: #555;
          }
        }
      }
    }
  }
}
.read {
  .control {
    height: 33px;
    justify-content: flex-end;
    span {
      display: block;
      width: 24px;
      height: 24px;
      margin-left: 20px;
      border-radius: 50%;
      background: #fbf6ed;
      overflow: hidden;
      border: 2px solid #958f8f;
      &.active2 {
        background: white;
      }
      &.active3 {
        background: #ebf4ea;
      }
      &.active4 {
        background: #e8f2f5;
      }
    }
    .reduce {
      margin-left: 64px;
      margin-right: 12px;
    }
    .add {
      margin-left: 12px;
    }
  }
  .txt {
    margin-top: 18px;
    padding: 10px 20px;
    line-height: 28px;
    background: url("../../assets/img/readBg.png") top left / 278px 246px repeat;
  }
}
.imgs {
  .imgList {
    width: 1200px;
    flex-wrap: wrap;
    margin-left: -16px;
    margin-top: 36px;
    .img {
      width: 284px;
      height: 284px;
      margin-left: 16px;
      margin-top: 16px;
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      p {
        position: absolute;
        bottom: 16px;
        left: 16px;
        font-size: 16px;
        font-weight: 44px;
        color: white;
      }
    }
  }
}
.color {
  color: #e6e6e6;
}
</style>